import { Modal, ModalProps, Form, Select, Row, Col, Alert, Radio, Spin, message } from 'antd';
import { useEffect, useState } from 'react';
import SurveysService from '../SurveysService';
import { FieldData } from 'rc-field-form/es/interface';
import ApiError from '../../core/ApiError';

type QRDownloadModalPops = ModalProps & {
  client: string,
  survey?: any,
  filters?: any,
}

const QRDownloadModal = ({ survey, client, filters, ...modalProps }: QRDownloadModalPops) => {
  const [ loading, setLoading ] = useState(false);
  const [ fileLoading, setFileLoading ] = useState(false);
  const [ tags, setTags ] = useState<any[]>([]);
  const [ query, setQuery ] = useState<string>('');

  const onFiltersChange = (changed: FieldData[], all: FieldData[]) => {
    const q = all.filter(a => a.value)
      .map(a => `${encodeURIComponent(a.name.toString())}=${encodeURIComponent(a.value)}`)
      .join('&');
    setQuery(q);
  };

  useEffect(() => {
    const func = async () => {
      try {
        setLoading(true);
        const tags = await SurveysService.getSurveyTags(client, survey.id);
        setTags(tags);
      }
      catch(err) {
        console.error(err);
        message.error((err as Error).message);
      }
      setLoading(false);
    };
    if(survey && survey.id) func();
  }, [survey, client]);

  useEffect(() => {
    if(!query) {
      setQuery(`format=svg&${Object.keys(filters||{}).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(filters[k])}`).join('&')}`);
    }
  }, [query, filters, survey, client]);

  const downloadQRs = async () => {
    try {
      setFileLoading(true);
      let anchor = document.createElement("a");
      document.body.appendChild(anchor);
      
      const blob = await SurveysService.downloadQRs(survey.uuid, query);
      let objectUrl = window.URL.createObjectURL(blob);
  
      anchor.href = objectUrl;
      anchor.download = `QRs - ${survey.title}.${blob.type === 'application/zip' ? 'zip' : blob.type === 'image/jpeg' ? 'jpg' : 'svg'}`;
      anchor.click();
  
      window.URL.revokeObjectURL(objectUrl);
    }
    catch(err) {
      if(err instanceof ApiError) {
        if(err.data.statusCode === 404) {
          message.error('No se encontraron QRs con los filtros seleccionados');
        }
        else {
          message.error(err.message);
        }
      }
      else message.error('Ocurrió un error al descargar el reporte')
      console.error(err);
    }

    setFileLoading(false);
  }

  return <Modal confirmLoading={fileLoading} destroyOnClose title="Descarga de QRs" okText="Descargar QRs" cancelText="Cerrar" {...modalProps} onOk={downloadQRs}>
    <strong>{survey.title}</strong>
    <p>Selecciona los filtros de los QRs que quieres descargar, o puedes dejarlos vacíos para descargarlos todos</p>
    <Form id="frmRptFlt" layout="vertical" onFieldsChange={onFiltersChange}>
            <Row gutter={8}>
              { loading && <Col span={24}><Spin spinning>Cargando...</Spin></Col> }
              { !loading && tags.filter(t => t.type === 'tag').map(tag => <Col key={tag.id} span={12}>
                <Form.Item name={tag.name} label={tag.name} initialValue={filters?.hasOwnProperty(tag.name) ? filters[tag.name]||undefined : undefined}>
                  <Select mode="multiple" placeholder="Todos">
                    { tag.values.map((value: any) => <Select.Option key={value} value={value}>{value}</Select.Option>) }
                  </Select>
                </Form.Item>
              </Col> )}
              { !loading && tags.filter(t => t.type === 'query').map(tag => <Col key={tag.id} span={12}>
                <Form.Item name={`qs_${tag.id}`} label={tag.name} initialValue={tag.values && tag.values.length > 0 ? tag.values[0].split(';')[1] : ''}>
                  <Select placeholder="Todos">
                    <Select.Option value="">Sin especificar</Select.Option>
                    { tag.values.map((value: any) => <Select.Option key={value} value={value.split(';')[1]}>{value.split(';')[0]}</Select.Option>) }
                  </Select>
                </Form.Item>
              </Col> )}
            </Row>
            <Form.Item name="format" style={{textAlign: 'center'}} initialValue="svg">
              <Radio.Group>
                <Radio value="svg">SVG</Radio>
                <Radio value="jpg">JPG</Radio>
              </Radio.Group>
            </Form.Item>
            <Alert
              message="¿Qué formato debo elegir?"
              description={<>
                <p style={{marginTop: 12}}><strong>SVG</strong>: Si vas a imprimir los QRs en grandes formatos, o si deseas modificar el diseño del QR.</p>
                <p><strong>JPG</strong>: Para mayor compatibilidad con tu computador.</p>
              </>}
              type="info"
              showIcon
            />
          </Form>
  </Modal>
};


export default QRDownloadModal;